// Single source of truth for the data-cache tag strings.
//
// These tags are written onto data-cache entries by the SSR data composables
// (useJobShopData / usePageData / useContentModules / useJobPageTemplateData) and
// purged by the cache-invalidation path (utils/Cache.ts, driven by Kafka events).
// Invalidation only works if the tag a writer stores is byte-identical to the tag
// the purger sends — so BOTH sides must build their tags here. Changing a format
// below is a deliberate, cross-cutting change (and breaks cacheTags.test.ts).

export function tenantTag(tenantId: string): string {
  return `tenantId:${tenantId}`
}

export function jobShopTag(jobShopId: string): string {
  return `jobShopId:${jobShopId}`
}

export function pageTag(pageId: string): string {
  return `pageId:${pageId}`
}
